import { AxiosResponse } from "axios"
import Schema from "validate"

import { request } from "../../request"
import { LeadRequestData } from "./hook"

const vehicleValuationSchema = new Schema({
  ActionType: String,
  VehicleType: String,
  DealershipName: String,
  DealershipGuid: String,
  Customer: {
    FirstName: String,
    LastName: String,
    Email: String,
    Mobile: String,
    Landline: String,
    Postcode: String,
  },
  Vehicle: {
    Registration: String,
    manufacturer: String,
    model: String,
  },
})

export const getLeadRequest = async (
  leadRequestData: LeadRequestData
): Promise<AxiosResponse<string>> => {
  const errors = vehicleValuationSchema.validate(leadRequestData)

  if (errors && errors.length) {
    throw new Error("Schema is invalid")
  }

  return request({
    url: "/vehicle-not-found/CreateSalesLead",
    method: "post",
    headers: {
      "Access-Control-Request-Methods": "*",
      "Access-Control-Allow-Origin": "*",
    },
    timeout: 120000,
    data: leadRequestData,
  })
}
